import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PinIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Pin",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m18.1 29.63-6.46-6.46L5 28.8c-.44.37-.97.64-1.56.77H3.3c-.04 0-.09.01-.14.01-.4 0-.73-.33-.73-.73v-.18c.14-.62.41-1.16.79-1.61s5.68-6.62 5.68-6.62l-6.48-6.5c-.24-.24-.4-.57-.4-.94 0-.57.36-1.05.86-1.23a8.623 8.623 0 0 1 5.88.61l-.05-.02 10.06-7.3-.5-.5c-.24-.24-.4-.58-.4-.95s.15-.71.4-.95l.27-.27c.24-.24.58-.4.95-.4s.71.15.95.4l9.11 9.11c.24.24.4.58.4.95s-.15.71-.4.95l-.27.27c-.24.24-.58.4-.95.4s-.71-.15-.95-.4l-.43-.41-7.3 10.08c.52 1.08.82 2.35.82 3.68 0 .75-.1 1.48-.28 2.18v-.06c-.18.5-.66.84-1.21.84-.36 0-.68-.14-.91-.37Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16 26.92c-.29 0-.58-.11-.81-.33L4.45 15.84a1.14 1.14 0 0 1 0-1.62 8.74 8.74 0 0 1 8.65-2.2l3.54-3.54c-.38-2.29.35-4.65 1.99-6.29a1.15 1.15 0 0 1 1.62 0l8.59 8.6c.45.45.45 1.17 0 1.62-1.64 1.64-4 2.37-6.29 1.99l-3.54 3.54c.9 3.05.07 6.37-2.2 8.65-.22.22-.52.33-.81.33M6.95 15.1l8.98 8.98c1.21-1.74 1.5-4.01.7-6.04-.17-.42-.06-.9.26-1.22l4.48-4.48c.29-.29.71-.4 1.1-.3 1.35.36 2.72.15 3.85-.54l-6.79-6.79c-.69 1.13-.9 2.5-.54 3.85.1.39 0 .81-.3 1.1l-4.48 4.48c-.32.32-.8.42-1.22.26a6.48 6.48 0 0 0-6.04.7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 29.28c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l7.67-7.67a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-7.67 7.67c-.22.22-.52.33-.81.33"
      })]
    })
  }));
};
PinIcon.displayName = 'PinIcon';